import SignUpContainer from '../../../../Containers/AdminContainer/Auth/SignUp';

const SignUpScreen = () => {
  return <SignUpContainer />;
};
export default SignUpScreen;
